import { createReducer } from './index';

const initialState = {};

export default createReducer(initialState, {});
